import { useMemo, memo } from 'react'
import JsonView from 'react18-json-view'
import cn from 'classnames'
import { message } from 'antd'
import 'react18-json-view/src/style.css'
import copy from 'copy-to-clipboard'
import styled from '@emotion/styled'
import { Icon } from '../../base/Icon'

interface JSONEditorProps {
  value: string
  className?: string
}

function parseJSON(jsonString: string) {
  try {
    return JSON.parse(jsonString)
  } catch (error) {
    console.error('解析 JSON 时出错:', error)
    return { error: 'Invalid JSON' }
  }
}

const StyledJsonView = styled(JsonView)`
  .json-view--pair {
    line-height: 16px;
    word-break: break-all;
  }
`

/** github doc: https://github.com/YYsuni/react18-json-view  */
function JSONEditorInner({ value, className }: JSONEditorProps) {
  const jsonObject = useMemo(() => parseJSON(value), [value])

  return (
    <div
      className={cn(
        'p-[12px] relative rounded-[4px] text-[12px] bg-[#F3F3F7]',
        className,
      )}
    >
      <div
        className={
          'absolute right-[8px] top-[8px] z-[10] flex items-center justify-center cursor-pointer w-[24px] h-[24px] rounded-[4px] hover:bg-[#626299] hover:bg-opacity-[0.12]'
        }
      >
        <Icon
          path='copy.svg'
          className='w-[16px]'
          onClick={() => {
            copy(value)
            message.success('已复制到剪切板')
          }}
        />
      </div>
      <StyledJsonView src={jsonObject} enableClipboard={false} />
    </div>
  )
}

export const JSONEditor = memo(JSONEditorInner)
